module.exports = __webpack_public_path__ + "static/media/first-login.8e2acd78.mp4";